/* RestoreDetailComponent.js */

"use strict";

const Renderer = require("./RestoreDetailRenderer");
const EventEmitter = require("events").EventEmitter;
const ScheduleVeilComponent = require("../../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");
const _ = require("lodash");

class RestoreDetailComponent extends EventEmitter {
    constructor(logger, GameEditor, backupEntity, DeviceEntity) {
        super(logger, GameEditor, backupEntity, DeviceEntity);
        this._backupEntity = backupEntity;
        this._device = DeviceEntity;
        this._gameEditor = GameEditor;
        this._title = "Restore";
        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        return this._renderer
            .shutdown()
            .then(() => {
                this._message = this._title = this._renderer = this._context = undefined;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "BaseCreateComponent.shutdown() error");
            });
    }

    restoreAction(opts) {
        this._context.resolve(opts);
    }

    scheduleRestore(RestoreName, workInput) {
        // const activeOrgId = _.get(this._gameEditor._activeView, "_gameEditor._activeOrgId");
        // const workTarget = {
        //     method: "multi",
        //     category: "entity",
        //     entityType: "Device",
        //     ids: [this._gameEditor._selectedDeviceIds],
        // };
        const titleMsg = "Schedule Restore";

        return this._gameEditor._model._modalUserFeedback
            .displayCustom(
                new ScheduleVeilComponent(this._logger, false, titleMsg, {
                    workType: "restore",
                    soln: undefined,
                    selectedRowsCount: 1,
                }),
                {dontHide: false}
            )
            .then((scheduleDef) => {
                let schedule = scheduleDef.schedule;
                let description = workInput.description;

                // backdoor to allow every minute schedules for internal testing
                if (_.get(schedule, "every.hour") && name === "everymin") {
                    _.set(schedule, "every.minute", schedule.every.hour);
                    delete schedule.every.hour;
                }
                workInput = Object.assign({}, workInput, scheduleDef.workInput);
                this._gameEditor._model._device.scheduleRestoreWork(
                    RestoreName,
                    description,
                    schedule,
                    workInput
                );

                return Promise.resolve();
            })
            .catch((err) => Promise.reject(err));
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    getSupportedOs() {
        const SUPPORTED_OS_STATIC = ["IOS/IOS XE", "NX-OS"];
        return Promise.resolve().then(() => {
            this._supportedOsList = SUPPORTED_OS_STATIC;
            return Promise.resolve();
        });
    }

    set "$teve.ui.context"(context) {
        this._context = context;
    }
}

module.exports = RestoreDetailComponent;
